import { Button } from '@platform/components';
import LinkedInLogo from './LinkedIn_icon.svg';

type LinkedInSignInButtonProps = {
  isRep?: boolean;
  isToSConfirmed?: boolean;
  onClickIfToSNotConfirmed?: () => void;
  orgInviteId?: string | null;
};

export const LinkedInSignUpButton = (props: LinkedInSignInButtonProps) => {
  const { isToSConfirmed, onClickIfToSNotConfirmed, isRep, orgInviteId } = { ...props };

  let logInHref = import.meta.env.VITE_API_HOST + '/login/linkedin' + '?is_rep=' + !!isRep;
  if (orgInviteId) {
    logInHref += `&org_invite_id=${orgInviteId}`;
  }

  //Because OAuth sign in isn't a button but a link, we use a button temporarily
  //To handle the press if the ToS isn't confirmed then when it is confirmed we replace it with the link
  if (!isToSConfirmed) {
    return (
      <div>
        <Button
          onPress={onClickIfToSNotConfirmed}
          variant='secondary-gray'
          size='lg'
          additionalClassnames='w-full'
        >
          <img height='24' width='24' src={LinkedInLogo} /> {'Create with LinkedIn'}
        </Button>
      </div>
    );
  }
  return (
    <Button href={logInHref} variant='secondary-gray' size='lg' additionalClassnames='w-full'>
      <img src={LinkedInLogo} height='24' width='24' /> {'Create with LinkedIn'}
    </Button>
  );
};
